export const currencyName = {
  PEN: 'Sol Peruano',
  CLP: 'Peso Chileno',
  COP: 'Peso Colombiano',
  ARS: 'Peso Argentino',
  MXN: 'Peso Mexicano',
  BRL: 'Real Brasileño',
  PYG: 'Guaraní Paraguayo',
  USD: 'Dólar estadounidense',
  EUR: 'Euro',
  GBP: 'Libra esterlina',
  CAD: 'Dólar canadiense',
  DEFAULT: 'No definida',
  CRC: 'Colón costarricense',
  USDT: 'USDT',
  USDC: 'USDC',
};

